const ProcessSection = () => {
  const steps = [
    {
      number: '01',
      title: 'Discovery Call',
      description: 'We start with a conversation to understand your business needs, current IT setup, and pain points.',
      icon: 'ri-phone-line'
    },
    {
      number: '02',
      title: 'Assessment & Proposal',
      description: 'Our team evaluates your requirements and creates a customized service plan with transparent pricing.',
      icon: 'ri-file-list-3-line'
    },
    {
      number: '03',
      title: 'Onboarding & Setup',
      description: 'We implement your chosen services with minimal disruption, ensuring smooth integration with your workflow.',
      icon: 'ri-settings-3-line'
    },
    {
      number: '04',
      title: 'Ongoing Support',
      description: 'Enjoy continuous monitoring, proactive maintenance, and responsive support to keep your systems running smoothly.',
      icon: 'ri-customer-service-2-line'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-violet-100 text-violet-700 text-sm font-semibold rounded-full mb-4">
            Our Process
          </div>
          <h2 className="text-5xl font-bold text-slate-900 mb-4">How We Work With You</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            A simple, transparent process designed to get you up and running quickly
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="bg-white rounded-2xl p-8 shadow-md hover:shadow-xl transition-all duration-300 h-full">
                <div className="flex items-center justify-between mb-6">
                  <span className="text-6xl font-bold text-violet-100">{step.number}</span>
                  <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-violet-500 to-purple-600 rounded-xl">
                    <i className={`${step.icon} text-white text-2xl`}></i>
                  </div>
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-3">{step.title}</h3>
                <p className="text-sm text-gray-600 leading-relaxed">{step.description}</p>
              </div>
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                  <i className="ri-arrow-right-line text-3xl text-violet-300"></i>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;